import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { PaymentGateways, StripeProductGeolocation } from '~/types/stripe-subscription'

import { RootState } from '../store'

const initialState: StripeProductGeolocation = {
  stripeProductId: '',
  stripePriceId: '',
  country: '',
  trialPeriodDays: 0,
  isDefault: false,
  paymentGateways: [],
}

const slice = createSlice({
  name: 'admin-subscription',
  initialState,
  reducers: {
    setStripeProductId: (state, action: PayloadAction<string>) => ({
      ...state,
      stripeProductId: action.payload,
      stripePriceId: '',
    }),

    setStripePriceId: (state, action: PayloadAction<string>) => ({
      ...state,
      stripePriceId: action.payload,
    }),

    setCountry: (state, action: PayloadAction<string>) => ({
      ...state,
      country: action.payload,
    }),

    setTrialPeriod: (state, action: PayloadAction<number>) => ({
      ...state,
      trialPeriodDays: action.payload,
    }),

    setPaymentGateway: (state, action: PayloadAction<{ key: PaymentGateways; flag: boolean }>) => ({
      ...state,
      paymentGateways: action.payload.flag
        ? [...state.paymentGateways, action.payload.key]
        : [...state.paymentGateways.filter((item) => item !== action.payload.key)],
    }),

    setIsDefault: (state, action: PayloadAction<boolean>) => ({
      ...state,
      isDefault: action.payload,
    }),
  },
})

export const selectStripeProduct = (state: RootState): StripeProductGeolocation => {
  return state.adminSubscription
}

export const { setStripeProductId, setStripePriceId, setCountry, setTrialPeriod, setPaymentGateway, setIsDefault } =
  slice.actions

export default slice.reducer
